import { Alert } from "react-bootstrap"
import './ErrorMessages.css';

export default function ErrorMessages({mensajes = []}) {

    return <>
        {(mensajes.length>0)?
            <ul className="error-messages">
                {mensajes.map((m,i) => <li key="i"><Alert variant="danger">{m}</Alert></li>)}
            </ul>:
            ""}
    </>

}